const MYOME_PREFIX = 'MyOme';

export type ProductTestNameSource = {
  name: string;
  product_test_name?: string | null;
};

export const stripMyOmePrefix = (name: string): string => {
  if (!name.startsWith(MYOME_PREFIX)) return name;
  const separatorIndex = name.indexOf(', ');
  return separatorIndex !== -1 ? name.slice(separatorIndex + 2) : name;
};

export const getProductTestDisplayName = (product: ProductTestNameSource): string => {
  const testName = product.product_test_name?.trim();
  return stripMyOmePrefix(testName || product.name);
};
